// extracted by mini-css-extract-plugin
module.exports = {"element":"Heading7_element__DPWRp"};